import { Fragment, ReactElement, useMemo } from 'react';
import { CivilUnionNotificationsResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CivilUnionNotificationsResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CivilUnionNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CivilUnionNotificationsResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchCivilUnionNotificationShared from '../../research-notifications/research-civil-union';

interface ResearchCivilUnionNotificationCivilStatusSharedProps {
  scope?: string;
}

const ResearchCivilUnionNotificationCivilStatusShared = ({
  scope,
}: ResearchCivilUnionNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/residenti/registrazione`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return CivilUnionNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CivilUnionNotificationsResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CivilUnionNotificationsResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CivilUnionNotificationsResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CivilUnionNotificationsResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchCivilUnionNotificationShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchCivilUnionNotificationCivilStatusShared.displayName =
  'Research Civil Union Notifications Page component';

export default ResearchCivilUnionNotificationCivilStatusShared;
